
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'WestHavenScore',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/WestHavenScore.vue